import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../style';

export namespace RunFlowSubMenuItemStyles {
  const cssPrefix = 'RunFlowSubMenuItemStyles';

  export const root = cssClass(cssPrefix, 'root', {
    padding: CommonStyles.Sizes.SmallSpace,
  });

  export const subMenuIcon = cssClass(cssPrefix, 'subMenuIcon', {
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'left',
    height: '28px'
  });

  export const subMenuText = cssClass(cssPrefix, 'subMenuText', {
    fontWeight: 'bold',
    fontSize: TabStyles.Typography.Sizing.Default,
    color: applyColor(DesignTokens.color.font.default.default, TabStyles.Typography.Color.PrimaryDark),
    lineHeight: `${CommonStyles.Sizes.LargeSpace}px`,
    display: 'inline-block',
  });

  export const subMenuHelpText = cssClass(cssPrefix, 'subMenuHelpText', {
    fontSize: TabStyles.Typography.Sizing.Default,
    color: applyColor(DesignTokens.color.font.default.secondary, TabStyles.Typography.Color.Secondary),
    lineHeight: `${CommonStyles.Sizes.LargeSpace}px`,
    whiteSpace: 'normal',
  });

  export const defaultText = cssClass(cssPrefix, 'defaultText', {
    lineHeight: `${CommonStyles.Sizes.LineHeight}px`,
    backgroundColor: 'transparent',
    display: 'inline-block',
    paddingLeft: CommonStyles.Sizes.SmallSpace,
    paddingRight: CommonStyles.Sizes.SmallSpace,
    marginLeft: CommonStyles.Sizes.MediumSpace,
    color: applyColor(DesignTokens.color.font.default.default, TabStyles.Typography.Color.Primary),
    outline: 'none'
  });
}
